export default "__VITE_ASSET__3f1f8116__"